// extracted by mini-css-extract-plugin
module.exports = {"returnBtn":"index-returnBtn-N188J"};